
import { Box, FormControl, InputBase, InputLabel, Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';

import { AsyncAutocomplete } from 'evee-ui-common/components/base';
import { apiService } from 'evee-ui-common/services';
import useRegion from 'store/modules/app/hooks/useRegion';

import { getDefaultLocationOptions, getLocationOptionIcon } from '../utils/locationOptions';

import styles from './styles';

const SearchLocationInput = ({
  value,
  multiline,
  placeholder,
  className,
  classes,
  onChange,
  ...rest
}) => {
  const { region } = useRegion();

  const renderLocationOptionJsx = (option) => (
    <Box className={classes.optionContainer}>
      {getLocationOptionIcon(option.icon)}
      <Typography noWrap>{option.name}</Typography>
    </Box>
  );

  const renderLocationInputJsx = (params) => (
    <div ref={params.InputProps.ref}>
      <InputBase
        fullWidth
        placeholder={placeholder || region.name}
        inputProps={{ ...params.inputProps, style: { padding: 0 } }}
        style={{
          padding: '4px 0 0 0',
        }}
      />
    </div>
  );

  return (
    <FormControl className={className} {...rest}>
      <InputLabel shrink style={{ fontWeight: 500 }}>
        Location
      </InputLabel>
      <AsyncAutocomplete
        noOptionsText="No matching location found"
        captionText="Start typing to choose location"
        requestMethod={apiService.location.getSearchLocations}
        defaultOptions={getDefaultLocationOptions()}
        displayField="name"
        value={value}
        renderOption={renderLocationOptionJsx}
        renderInput={renderLocationInputJsx}
        classes={{ paper: classes.paper, listbox: classes.listbox, option: classes.option }}
        onChange={onChange}
      />
    </FormControl>
  );
};

SearchLocationInput.propTypes = {
  value: PropTypes.object,
  multiline: PropTypes.bool,
  placeholder: PropTypes.string,
  className: PropTypes.string,
  classes: PropTypes.shape({
    paper: PropTypes.string.isRequired,
    option: PropTypes.string.isRequired,
    optionContainer: PropTypes.string.isRequired,
    listbox: PropTypes.string.isRequired,
  }).isRequired,
  onChange: PropTypes.func,
};

SearchLocationInput.defaultProps = {
  value: {},
  multiline: false,
  placeholder: '',
  className: '',
  onChange: () => {},
};

export default withStyles(styles)(SearchLocationInput);
